// extracted by mini-css-extract-plugin
export default {"form":"AfishaForm_form__toMBt","button":"AfishaForm_button__PSk+s","formGroup":"AfishaForm_formGroup__vrwMn"};